var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('AppPreloader',{staticClass:"landing-preloader"}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }